/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Step_TimeInputs */

const en_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const es_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const de_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

const zh_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间`)
};

const ar_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوقت`)
};

const fr_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure`)
};

const vi_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ`)
};

const sw_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wakati`)
};

const th_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลา`)
};

const bs_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrijeme`)
};

const ja_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

const ko_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시간`)
};

const pt_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

const it_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orario`)
};

const sv_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid`)
};

const nl_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijd`)
};

const da_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid`)
};

const nb_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid`)
};

const fi_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aika`)
};

const pl_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas`)
};

const ru_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время`)
};

const tr_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat`)
};

const hi_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय`)
};

const id_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu`)
};

const ms_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa`)
};

const cs_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čas`)
};

const el_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ώρα`)
};

const he_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שעה`)
};

const af_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyd`)
};

const hu_booking_step_time = /** @type {(inputs: Booking_Step_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Időpont`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Booking_Step_TimeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_step_time = /** @type {((inputs?: Booking_Step_TimeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Step_TimeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_step_time(inputs)
	if (locale === "de") return de_booking_step_time(inputs)
	if (locale === "zh") return zh_booking_step_time(inputs)
	if (locale === "ar") return ar_booking_step_time(inputs)
	if (locale === "fr") return fr_booking_step_time(inputs)
	if (locale === "vi") return vi_booking_step_time(inputs)
	if (locale === "sw") return sw_booking_step_time(inputs)
	if (locale === "th") return th_booking_step_time(inputs)
	if (locale === "bs") return bs_booking_step_time(inputs)
	if (locale === "ja") return ja_booking_step_time(inputs)
	if (locale === "ko") return ko_booking_step_time(inputs)
	if (locale === "pt") return pt_booking_step_time(inputs)
	if (locale === "it") return it_booking_step_time(inputs)
	if (locale === "sv") return sv_booking_step_time(inputs)
	if (locale === "nl") return nl_booking_step_time(inputs)
	if (locale === "da") return da_booking_step_time(inputs)
	if (locale === "nb") return nb_booking_step_time(inputs)
	if (locale === "fi") return fi_booking_step_time(inputs)
	if (locale === "pl") return pl_booking_step_time(inputs)
	if (locale === "ru") return ru_booking_step_time(inputs)
	if (locale === "tr") return tr_booking_step_time(inputs)
	if (locale === "hi") return hi_booking_step_time(inputs)
	if (locale === "id") return id_booking_step_time(inputs)
	if (locale === "ms") return ms_booking_step_time(inputs)
	if (locale === "cs") return cs_booking_step_time(inputs)
	if (locale === "el") return el_booking_step_time(inputs)
	if (locale === "he") return he_booking_step_time(inputs)
	if (locale === "af") return af_booking_step_time(inputs)
	if (locale === "hu") return hu_booking_step_time(inputs)
	return en_booking_step_time(inputs)
});